const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      ServicesTemplate {
        advisoryServiceSubtitle
        managedServiceSubtitle
        servicesOfferings {
          offeringTitle
          offeringButtonTitle
          aboutTheService
          advisoryService {
            listItem
          }
          managedService {
            listItem
          }
        }
      }
    }
  }
`;
export default fetchData;
